import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
import Button from '../components/Button';
import AboutPageImg from '../assets/images/aboutPageImg2.jpg';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .job__info {
    margin-top: 2rem;
    margin-bottom: 8rem;
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 8px;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;

    &:last-child {
      margin-bottom: 5rem;
    }
  }
  .about__info__heading {
    font-size: 4.2rem;
    text-transform: uppercase;
    margin-bottom: 4rem;
    color: var(--white);
    font-weight: 700;
    letter-spacing: 1px;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3.5rem;
      margin-bottom: 3rem;
    }
    .about__info__items {
      margin-top: 10rem;
    }
    .about__info__item {
      margin-bottom: 8rem;

      &:last-child {
        margin-bottom: 3rem;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    .about__info__heading {
      font-size: 3rem;
    }
    .about__info__items {
      margin-top: 8rem;
    }
    .about__info__item {
      margin-bottom: 6rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Soham Nandi</span>
              </p>
              <h2 className="about__heading">A Data Science Enthusiast</h2>
              <div className="about__info">
                <PText>
                  I'm passionate about leveraging technology to solve real-world
                  challenges, and my journey from a medical aspirant to a tech
                  enthusiast has been nothing short of transformative.
                  <br /> <br />
                  I possess a diverse skill set encompassing a wide array of
                  technologies and tools. Proficient in Python, SQL, C++. My
                  expertise extends to machine learning and artificial
                  artificial intelligence techniques such as support vector
                  machines, neural networks, convolutional neural networks, and
                  natural language processing, with hands-on experience in
                  frameworks like TensorFlow. Additionally, I am well-versed in
                  utilizing cloud services such as AWS, Docker for
                  containerization, and Git for version control, ensuring
                  efficient development workflows and deployment processes. With
                  a solid foundation in database management systems including
                  MongoDB, RDBMS, and MySQL. I am familiar with various web
                  frameworks including ReactJS and NodeJS.
                  <br />
                  <br />
                  LeetCode is like daily pill to me, I am addicted to it. When
                  it comes to problem-solving, I thrive on challenges. While I
                  may not have all the answers immediately, I'm relentless in my
                  pursuit of solutions.
                </PText>
              </div>
              <Button
                btnText="Download Resume"
                btnLink="https://drive.google.com/file/d/1NdgadDvpG53vtQTM64b8IsSK-QcZ4Fqo/view?usp=sharing"
              />
            </div>
            <div className="right">
              <img src={AboutPageImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>

              <AboutInfoItem
                title="Master’s"
                items={["Portland State University (Sep'22 - June'24)"]}
              />
              <AboutInfoItem
                title="Bachelor’s"
                items={["Techno India University (June'18 - June'22)"]}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>

              <AboutInfoItem
                title="Languages"
                items={['Python', 'C++', 'SQL', 'R', 'JavaScript']}
              />
              <AboutInfoItem
                title="Data Science"
                items={[
                  'Machine Learning',
                  'Deep Learning',
                  'NLP',
                  'Data Science',
                  'Data Mining',
                  'Data Analysis',
                  'Statistics',
                ]}
              />
              <AboutInfoItem
                title="Libraries/Frameworks"
                items={['TensorFlow', 'PyTorch', 'Scikit-learn', 'Pandas']}
              />
              <AboutInfoItem
                title="Cloud Technologies"
                items={['AWS', 'GCP']}
              />
              <AboutInfoItem
                title="Web Dev"
                items={['ReactJS', 'NodeJS', 'HTML', 'CSS']}
              />
              <AboutInfoItem
                title="Database"
                items={['MongoDB', 'MySQL', 'PostgreSQL']}
              />
              <AboutInfoItem
                title="Others"
                items={['Docker', 'Kafka', 'Git']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiences</h1>

              <AboutInfoItem
                title="April'24 - Current"
                items={['State Street: Data Scientis']}
              />
              <AboutInfoItem
                title="Oct'19 - July'22"
                items={['Freshworks Inc: Data Scientist']}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
